module.exports = __webpack_public_path__ + "static/img/elven_skirmisher3.81f5168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/elven_skirmisher3.png
// module id = 9ZqQ
// module chunks = 0